/** Customer-facing labels for Overview table cells (display only). */

export const EVIDENCE_STRENGTH_NOT_EVALUATED_TOOLTIP =
  'Not evaluated means no human review has confirmed evidence strength yet.';

export const EVIDENCE_STRENGTH_NEW_ACTIVITY_TOOLTIP =
  'New observations arrived after the latest Signed Safety Scan. Review the new activity before updating evidence strength.';

export const IMPACT_TRACKING_NOT_MEASURED_TOOLTIP =
  'Not measured means follow-up impact has not been checked yet.';

export function displayEvidenceProofLabel(raw: string | null | undefined): string {
  const text = String(raw || '').trim();
  if (!text) return 'Not evaluated';
  const key = text.toLowerCase();
  if (key.includes('not evaluated') || key.includes('unknown')) return 'Not evaluated';
  if (key.includes('new activity') || key.includes('pending review (new activity)')) {
    return 'Pending review (new activity)';
  }
  if (key.includes('media limited') || key === 'limited') return 'Media limited';
  if (key.includes('ready') && !key.includes('not')) return 'Ready';
  if (key.includes('pending')) return 'Pending';
  if (key.includes('missing')) return 'Not evaluated';
  if (key.includes('failed') || key.includes('degraded')) return 'Media limited';
  return text;
}

export function evidenceStrengthValueTooltip(label: string): string | undefined {
  if (label === 'Pending review (new activity)') return EVIDENCE_STRENGTH_NEW_ACTIVITY_TOOLTIP;
  if (label === 'Not evaluated') return EVIDENCE_STRENGTH_NOT_EVALUATED_TOOLTIP;
  return undefined;
}

export function displayFollowupMeasurementLabel(raw: string | null | undefined): string {
  const text = String(raw || '').trim();
  if (!text) return 'Not measured';
  const key = text.toLowerCase();
  if (key.includes('measurement pending')) return 'Measurement pending';
  if (key.includes('not measured') || key === 'missing') return 'Not measured';
  if (key.includes('measured') && !key.includes('not') && !key.includes('missing')) return 'Measured';
  if (key.includes('missing')) return 'Missing';
  return text;
}

export function impactTrackingValueTooltip(label: string): string | undefined {
  if (label === 'Not measured') return IMPACT_TRACKING_NOT_MEASURED_TOOLTIP;
  return undefined;
}

export function formatRiskOwnerCell(owner: string | null | undefined): string {
  const value = String(owner || '').trim();
  if (!value || /^not assigned$/i.test(value) || /^unassigned$/i.test(value)) {
    return 'Not assigned';
  }
  return value;
}

export function formatActionOwnerCell(owner: string | null | undefined): string {
  return formatRiskOwnerCell(owner);
}

export function formatOwnerGapSummary(
  patternOwner: string | null | undefined,
  followupOwner: string | null | undefined,
): string | null {
  const riskOwner = formatRiskOwnerCell(patternOwner);
  const actionOwner = formatActionOwnerCell(followupOwner);
  const riskMissing = riskOwner === 'Not assigned';
  const actionMissing = actionOwner === 'Not assigned';
  if (riskMissing && actionMissing) return 'Risk owner and action owner missing';
  if (riskMissing) return 'Risk owner missing';
  if (actionMissing) return 'Action owner missing';
  return null;
}
